import React from "react";
import {createRoot} from "react-dom/client";
import {Provider} from "react-redux";
import {store} from "./store/store";
import App from "./App";
import "./index.css";
import {BrowserRouter} from "react-router-dom";
import {AuthProvider, type AuthProviderProps} from "react-oidc-context";
import {WebStorageStateStore} from "oidc-client-ts";
import {
  oidcServiceUrl,
  oidcClientId,
  oidcPostLogoutRedirectUri,
  oidcRedirectUri,
  oidcScope,
  oidcDefaultProviderId,
  adminPanelBasePath
} from "./infrastructure/config";

const container = document.getElementById("react-app");

const root = createRoot(container);

const oidcConfig: AuthProviderProps = {
  authority: oidcServiceUrl,
  client_id: oidcClientId,
  redirect_uri: oidcRedirectUri,
  post_logout_redirect_uri: oidcPostLogoutRedirectUri,
  scope: oidcScope,
  acr_values: (oidcDefaultProviderId ?? "").length > 0 ? `idp:${oidcDefaultProviderId}` : undefined,
  response_type: "code",
  response_mode: "query",
  monitorSession: false,
  automaticSilentRenew: false,
  filterProtocolClaims: true,
  stateStore: new WebStorageStateStore({store: window.sessionStorage}),
  userStore: new WebStorageStateStore({store: window.sessionStorage}),
  onSigninCallback: (): void => {
    window.history.replaceState({}, document.title, window.location.pathname);
  }
};

root.render(
  <AuthProvider {...oidcConfig}>
    <React.StrictMode>
      <BrowserRouter basename={adminPanelBasePath}>
        <Provider store={store}>
          <App />
        </Provider>
      </BrowserRouter>
    </React.StrictMode>
  </AuthProvider>
);
